import type { TripItineraryItem, TripItemWithoutDay } from 'tripPlanner/api/types'
import { isHotelSavedData } from 'tripPlanner/utils/savedItemDataGuards'
import { nonSimpleMoveItemTypes } from 'tripPlanner/types/tripItem'

export type TripMovePlacement =
  | { placementType: 'before'; itemId: number }
  | { placementType: 'after'; itemId: number }
  | { placementType: 'start' }
  | { placementType: 'end' }

export type MovableTripItem = TripItineraryItem | TripItemWithoutDay

const HIDDEN_OR_COMPLEX_ITEM_TYPES = new Set<string>(nonSimpleMoveItemTypes)

function getSavedStayDuration(item: MovableTripItem): number | undefined {
  const savedItemData = item.savedItemData
  if (!isHotelSavedData(savedItemData)) return undefined
  return typeof savedItemData.packageNumberOfNights === 'number' ? savedItemData.packageNumberOfNights : undefined
}

function getItemTotalDays(item: MovableTripItem): number | undefined {
  if (!('totalDays' in item)) return undefined
  return item.totalDays
}

function getItemDayOfStay(item: MovableTripItem): number | undefined {
  if (!('dayOfStay' in item)) return undefined
  return item.dayOfStay
}

export function isTripItemComplexMove(item: MovableTripItem): boolean {
  if (HIDDEN_OR_COMPLEX_ITEM_TYPES.has(item.type)) return true
  if (item.type !== 'ACCOMMODATION') return false

  return (
    (getItemTotalDays(item) ?? 1) > 1 ||
    (getItemDayOfStay(item) ?? 1) > 1 ||
    (getSavedStayDuration(item) ?? 1) > 1
  )
}

export function canMoveTripItemToAnotherDay(item: MovableTripItem): boolean {
  if ('isBooked' in item && item.isBooked) return false
  return !isTripItemComplexMove(item)
}
